import Configuration from '../core/configuration'; 
import BaseService from './baseService'; 



export class HardwareVersionsService extends BaseService {
    constructor(){
        const baseUrl = Configuration.traffic.hardwareVersions;
        super(baseUrl);
    }
}  